import React, { forwardRef, useState } from "react";
import PropTypes from "prop-types";
import {
	Button,
	Input,
	message,
	Modal,	
	Space,
} from "antd";

export const CreateCategoryModal = forwardRef(({ onSendCategory = () => {} }, ref) => {
	const [editedValue, setEditedValue] = useState("");
	const [open, setOpen] = useState(false);

	React.useImperativeHandle(ref, () => ({
		openModal: () => setOpen(true),
	}));

	const handleCreateCategory = () => {
		if (editedValue.trim() === "") {
			message.error("Por favor, ingresa un valor válido.");
			return;
		}
		onSendCategory(editedValue);
		setOpen(false);
		setEditedValue("");
	};

	return (
		<Modal
			title="Crear Categoría"
			open={open}
			onCancel={() => setOpen(false)}
			footer={() => (
				<Space>
					<Button onClick={() => setOpen(false)}>Cancelar</Button>
					<Button type="primary" onClick={handleCreateCategory}>
						Crear
					</Button>
				</Space>
			)}
		>
			<Input
				value={editedValue}
				maxLength={20}
				showCount
				placeholder="Nueva Clasificación"
				onChange={(e) => {
					const filteredValue = e.target.value
						.replace(/-/g, "_");
						
					setEditedValue(filteredValue);
				}}
			/>
		</Modal>
	);
}
);

CreateCategoryModal.displayName = "CreateCategoryModal";

CreateCategoryModal.propTypes = {
	onSendCategory: PropTypes.func,
};